
const domain = window.location.hostname;
export const APPID = 7;

export const API_URL = process.env.REACT_APP_API_URL || 'https://api.merlinrecorder.com';
export const MERLIN_SOCKET_URL = process.env.REACT_APP_MERLIN_SOCKET_URL || 'https://merlinrecorder.com/socket/io';

export const GOOGLE_MAPS_API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY || 'AIzaSyAK4_SLUdT4OQ5fhk5HEuVdT2s2kgs-8yo';

export const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID || '1089449305948-mra7acqdun5djo68sd64ept2lost7hnb.apps.googleusercontent.com';
export const MICROSOFT_CLIENT_ID = process.env.REACT_APP_MICROSOFT_CLIENT_ID || '80bcf1e8-c37b-49b6-8f03-590fd799d50d';

export const LOGIN_REDIRECT_URI = process.env.REACT_APP_LOGIN_REDIRECT_URI || `https://${domain}/auth`;